import type { RouteObject } from "react-router";
import { Navigate } from "react-router";
import { detailStackRoute } from "@/features/detail/detail.routes";
import { JobList } from "./job-list/JobList";
import { JobSchedule } from "./job-schedule/JobSchedule";
import { JOB_LIST_PATH, JOB_LIST_SEGMENT, JOB_SCHEDULE_SEGMENT, JOB_SEGMENT } from "./job.paths";

export const jobRoute: RouteObject = {
  path: JOB_SEGMENT,
  children: [
    { index: true, element: <Navigate replace to={JOB_LIST_PATH} /> },
    {
      path: JOB_LIST_SEGMENT,
      element: <JobList />,
      children: [detailStackRoute],
    },
    { path: JOB_SCHEDULE_SEGMENT, element: <JobSchedule /> },
  ],
};
